import React, { MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { pathname, forwardUrlParams } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  login: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    marginTop: theme.spacing(2),
  },
  loginText: { marginRight: theme.spacing(0.5) },
}));

export default function SignInLink({ text }: { text: string }) {
  const classes = useStyles();
  const history = useHistory();

  function handleClick(e: MouseEvent<HTMLElement>) {
    e.preventDefault();
    history.push({
      pathname: pathname.preLogin.login.url,
      search: forwardUrlParams(),
    });
  }

  return (
    <div className={classes.login}>
      <Typography variant="body2" className={classes.loginText}>
        {text}
      </Typography>
      <Link href="#" onClick={handleClick}>
        <Typography variant="body2">Sign In</Typography>
      </Link>
    </div>
  );
}
